module.exports = __webpack_public_path__ + "img/transparent-diamond.74fd4e1d.png";